import { InfiniteList, type PaginatedList } from "@mylaunch/components/ui"
import type { Post } from "@apps/gwservice/types"
import { PostCard } from "~/features/feed/components/post-card"
import type { Result } from "@praha/byethrow"

interface Props {
  initialItems: Post[]
  initialNextPage?: number
  loadMore: (page: number) => Result.ResultAsync<PaginatedList<Post>, string>
}

export function InfinitePostList({ initialItems, initialNextPage, loadMore }: Props) {
  return (
    <InfiniteList items={initialItems} initialNextPage={initialNextPage} loadMore={loadMore} className="flex flex-col gap-3 p-2 pt-3">
      {(post) => <PostCard post={post} />}
    </InfiniteList>
  )
}
